import {
    AD_STATUS_FORSALE,
    AD_STATUS_SOLD,
    commonUtils,
    COUNTRY_FINLAND_ID,
    MAX_MILEAGE,
    MIN_MILEAGE,
} from './common_utils';

import { sellVehiclePriceSlider, VEHICLE_PRICE_PREFERENCE } from './search/sell_vehicle_price_slider';
import { sellVehicleKilometerSlider, VEHICLE_KILOMETER_THRESHOLD_BANNA } from './search/sell_vehicle_kilometer_slider';
import { sellVehicleLoanSlider, VEHICLE_LOAN } from './search/sell_vehicle_loan_slider';

export const checkSellAdFields = {
    init() {
        let $body = $('body');

        $body.on('click', '.showHideRecommendationTool', function () {
            checkSellAdFields.showHideForm(this);
        });

        $body.on('click', '.processVerifiedTopLinks, #verifiedAdLink', function () {
            // Smooth scroll to the target element
            $('html, body').animate(
                {
                    scrollTop: $('#verifiedAdSectionDiv').offset().top,
                },
                500,
                function () {
                    $('#sellVerifiedAd').trigger('click');
                }
            );
        });

        // Show/hide sections in mobile view
        $body.on('click', '#bidOfferBanna', function () {
            checkSellAdFields.toggleSellVehicleSections('bidOfferBannaDiv', 'bidOfferBanna');
        });
    },
    transferOma($vertical) {
        let $mileage = $.trim($('#mileage').val());
        let $registerNumber = $.trim($('#registerNumber').val());

        if (this.validate($mileage, $registerNumber)) {
            commonUtils.dataLayer.genericDataLayerEvent('priceEstimateFromOmaNettix');
            window.location.href = `${commonUtils.getAppObject().data('oma-nettix-url')}/lisaa-ajoneuvo/?regNumber=${$registerNumber}&mileage=${$mileage}&vertical=${$vertical}`;
        }
    },
    displayVerifiedAdForm() {
        commonUtils.dataLayer.genericData({
            event: 'smartsale_funnel',
            internal_source: commonUtils.getVerticalName().toLowerCase(),
            step: 'create_a_verified_ad',
            step_number: 1,
        });

        $('.verifiedRegisterNumber').removeClass('vehicle-reg-no');
        $('.vehicleRegisterNumber').val('');
    },
    processVerifiedAd(vertical) {
        let $vehicleRegisterNumber = $('#vehicleRegisterNumber');
        let registerNumber = $vehicleRegisterNumber.val();
        if (commonUtils.isValidRegistrationNumber(registerNumber)) {
            $('.errorMessage').text(Translations.sell_ad.check_register_number);
            $('.errorMessage').show();
            $vehicleRegisterNumber.focus();
            return false;
        }
        const searchByIdToken = $('#app').data('csrf-search-by-id');
        $.ajax({
            type: 'POST',
            url: Routing.generate('search_by_id'),
            data: {
                ad_id: registerNumber,
                process_verified_ad: true,
                token: searchByIdToken,
            },
            async: false,
        }).done(function (data) {
            if (data.success === false && data.message) {
                alert(data.message);
                return undefined;
            }
            if (data.success) {
                if (data.adCountry !== COUNTRY_FINLAND_ID) {
                    $('.errorMessage').text(Translations.sell_ad.invalid_outside_finland_ad);
                    $('.errorMessage').show();
                    $vehicleRegisterNumber.focus();
                    return false;
                }

                if (data.adStatus !== AD_STATUS_FORSALE) {
                    if (data.adStatus === AD_STATUS_SOLD) {
                        let updateAdUrl = `${Routing.generate('own_ad_list')}?adStatus=${AD_STATUS_SOLD}`;
                        $('#renewOldAdInstruction a').attr('href', updateAdUrl);
                    }
                    window.$.colorbox({ inline: true, href: '#renewOldAdInstruction' });

                    return false;
                }
            }

            commonUtils.dataLayer.genericData({
                event: 'smartsale_funnel',
                internal_source: commonUtils.getVerticalName().toLowerCase(),
                step: 'confirm_reg_number',
                step_number: 2,
            });

            let verifyAdLink = commonUtils.getVerifyAdLink(registerNumber, vertical);
            if (!commonUtils.isUserLogin()) {
                almaTunnusLogin.init('sell_page_verified_ad', '', verifyAdLink);
                return false;
            }
            window.location.href = verifyAdLink;
            return undefined;
        });
        return undefined;
    },
    toggleSellVehicleSections($id, $textId) {
        $(`#${$id}`).toggleClass('sell-vehicle__panel-for-mobile-open');
        if ($(`#${$id}`).hasClass('sell-vehicle__panel-for-mobile-open')) {
            $(`#${$textId}`).text(Translations.show_less);
        } else {
            $(`#${$textId}`).text(Translations.show_more);
        }
    },
    validate($mileage, $registerNumber) {
        if (commonUtils.isDealerLogin()) {
            alert(Translations.sell_ad.oma_seller_post_only);
            return false;
        }

        let isError = false;
        $('.registerNumberError, .mileageError').text('').hide();
        if (!$registerNumber || commonUtils.isValidRegistrationNumber($registerNumber)) {
            const errorMsg = !$registerNumber
                ? Translations.missing_mandatory
                : Translations.sell_ad.register_number_invalid;
            $('.registerNumberError').text(errorMsg).show();
            isError = true;
        }

        if (!$mileage || !$.isNumeric($mileage) || $mileage < MIN_MILEAGE || $mileage > MAX_MILEAGE) {
            const errorMsg = !$mileage ? Translations.missing_mandatory : Translations.sell_ad.mileage_invalid;
            $('.mileageError').text(errorMsg).show();
            isError = true;
        }

        return !isError;
    },
    showHideFaqPara(element) {
        $(element).toggleClass('show-hide-next-para');
    },
    showHideForm(element) {
        $(element).parent('.sell-vehicle__recommendation-tool').toggleClass('recommendation-tool-open');
    },
    initSlider(slider, sliderName, fromElement) {
        slider.init({
            sliderName: $(sliderName),
            fromElement: $(fromElement),
        });
    },
    recommendSellingMethod(_siteCode) {
        $('html, body').animate({ scrollTop: $('#sell_vehicle').offset().top }, { duration: 1 });

        const vehicleLoan = $('#vehicleLoanValue').val(); // 0 = No loan, 1 = Loan
        const kilometer = Number($('#kilometersValue').val());
        const price = $('#priceValue').val(); // 0 = Least effort, 1 = Both equally, 2 = Best price

        $('#verifiedAdSectionDiv, #basicAdSectionDiv, #bidOfferBannaDiv').removeClass('this-is-recommended');

        let recommendedDiv = '#basicAdSectionDiv';

        // Define the thresholds based on siteCode
        const kilometerThreshold = commonUtils.isNettimoto()
            ? VEHICLE_KILOMETER_THRESHOLD_BANNA.MOTO
            : VEHICLE_KILOMETER_THRESHOLD_BANNA.AUTO;
        const isLeastEffortOrBothEqual = [
            VEHICLE_PRICE_PREFERENCE.LEAST_EFFORT,
            VEHICLE_PRICE_PREFERENCE.BOTH_EQUAL,
        ].includes(price);
        const isKilometerUnder = kilometer < kilometerThreshold;
        const isKilometerOver = kilometer > kilometerThreshold;

        if (vehicleLoan === VEHICLE_LOAN.NO_LOAN) {
            const isNettiautoVerifiedAdSection =
                commonUtils.isNettiauto() &&
                (price === VEHICLE_PRICE_PREFERENCE.BEST_PRICE || (isLeastEffortOrBothEqual && isKilometerOver));
            const isNettimotoOrNettikaravaaniVerifiedAdSection =
                (commonUtils.isNettimoto() || commonUtils.isNettikaravaani()) &&
                (isKilometerOver || (isKilometerUnder && price === VEHICLE_PRICE_PREFERENCE.LEAST_EFFORT));

            if (isNettiautoVerifiedAdSection || isNettimotoOrNettikaravaaniVerifiedAdSection) {
                recommendedDiv = '#verifiedAdSectionDiv';
            }
        }

        // Common condition moved outside
        if (isKilometerUnder && isLeastEffortOrBothEqual && recommendedDiv === '#basicAdSectionDiv') {
            recommendedDiv = '#bidOfferBannaDiv';
        }

        $(recommendedDiv).addClass('this-is-recommended');
    },
};

$(function () {
    checkSellAdFields.init();

    const sliders = [
        [sellVehicleLoanSlider, '#vehicleLoanSlider', '#vehicleLoan'],
        [sellVehicleKilometerSlider, '#kilometerSlider', '#kilometers'],
        [sellVehiclePriceSlider, '#priceSlider', '#price'],
    ];

    sliders.forEach(([slider, id, target]) => checkSellAdFields.initSlider(slider, id, target));
});
